import { createClient } from '@supabase/supabase-js';

// İŞTE BURASI DÜZELDİ! Senin projenin dünyadaki gerçek ve tek adresi bu:
const supabaseUrl = 'https://qaftudujqyzadhnuwrbg.supabase.co';

// BUNA HİÇ DOKUNMADIM, ÇÜNKÜ BU KESİNLİKLE DOĞRU YAZILMIŞ:
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFhZnR1ZHVqcXl6YWRobnV3cmJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1NjE5MzIsImV4cCI6MjA4ODEzNzkzMn0.lN8es2AYQgfyr6huyOjnLnM4f-XT4y_P559gb0FxOYE';

// Motoru çalıştırıyoruz!
export const supabase = createClient(supabaseUrl, supabaseAnonKey);